import React from 'react';
import ButtonCustom from '../Button/ButtonCustom';
import TextUnderline from '../TextUnderline/TextUnderline';
import './ContactMain.scss';
import { useTranslation } from 'react-i18next';

function ContactMain() {
  const { t } = useTranslation();

  return (
    <section className="contact-main">
      <div className="contact-main-container">
        <div className="contact-main-content">
          <div className="contact-about">
            <div className="contact-about-content">
              <div className="contact-about-top">
                <TextUnderline className="contact-about-title">
                  {t('contact.title')}
                </TextUnderline>
                <br />
                <TextUnderline className="contact-about-title">
                  {t('contact.subtitle')}
                </TextUnderline>

                <p className="contact-about-desc">
                  {t('contact.description')}
                </p>
              </div>
              <div className="contact-about-bottom">
                <div className="contact-about-sub-title-wr">
                  <TextUnderline className="contact-about-sub-title">
                    {t('contact.selectText')}
                  </TextUnderline>
                </div>

                <div className="button-gr">
                  <ButtonCustom>{t('contact.categories.fineArt')}</ButtonCustom>
                  <ButtonCustom>{t('contact.categories.graphicDesign')}</ButtonCustom>
                  <ButtonCustom>{t('contact.categories.illustration')}</ButtonCustom>
                  <ButtonCustom>{t('contact.categories.advertising')}</ButtonCustom>
                  <ButtonCustom>{t('contact.categories.game')}</ButtonCustom>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-form">
            <div className="user-box">
              <input type="text" className="user-box-input" required />
              <label className="user-box-label">{t('contact.form.name')}</label>
            </div>
            <div className="user-box">
              <input type="text" className="user-box-input" required />
              <label className="user-box-label">{t('contact.form.company')}</label>
            </div>
            <div className="user-box">
              <input type="text" className="user-box-input" required />
              <label className="user-box-label">Email</label>
            </div>
            <div className="user-box">
              <textarea rows={10} className="user-box-input" required />
              <label className="user-box-label">
                {t('contact.form.message')}
              </label>
            </div>
            <button className="contact-form-bottom">
              <TextUnderline
                bottom={-1}
                style={{ fontSize: 24, lineHeight: '30px' }}
                borderheight={3}
              >
                {t('contact.form.send')}
              </TextUnderline>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactMain;
